<script setup lang="ts">
interface ITabs {
	initialTab?: string;
	disabled?: boolean;
	tabClass?: string;
	tabs: {
		name: string;
		value: string;
		count?: number;
		disabled?: boolean;
	}[];
}

const props = defineProps<ITabs>();
const emit = defineEmits(["onUpdate"]);

const active = ref("");

onMounted(() => {
	active.value = props.initialTab || props.tabs[0].value;
});
const handleClick = (tab: string) => {
	if (props.disabled) return;
	active.value = tab;
	emit("onUpdate", tab);
};
</script>

<template>
	<div class="flex">
		<div
			v-for="tab in tabs"
			:key="tab.value"
			@click="handleClick(tab.value)"
			:class="[
				'flex flex-1 justify-center items-center font-bold text-xs h-8 border-b-2 cursor-pointer relative transition-all',
				active === tab.value ? 'text-identity border-b-identity dark:border-b-identity' : 'border-b-light-600 dark:border-b-dark-400',
				tabClass,
			]"
		>
			<span class="flex items-center gap-1 overflow-hidden whitespace-nowrap text-ellipsis"
				>{{ tab.name }}
				<span v-if="tab.count" class="flex items-center justify-center w-5 h-5 rounded-full bg-light-50 text-identity">
					{{ String(tab.count).padStart(2, "0") }}
				</span>
			</span>
		</div>
	</div>
</template>
